import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface WeekPlanTask {
  id: string;
  projectId: string;
  taskNumber: string;
  task: string;
  startDate: string;
  targetDate?: string;
  status: string;
  comments?: string;
}

export interface CreateWeekPlanTaskDto {
  projectId: string;
  taskNumber: string;
  task: string;
  startDate: string;
  targetDate?: string;
  status: string;
  comments?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WeekPlanTaskService {
  private apiUrl = `${environment.apiUrl}/WeekPlanTask`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<WeekPlanTask[]> {
    return this.http.get<WeekPlanTask[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<WeekPlanTask> {
    return this.http.get<WeekPlanTask>(`${this.apiUrl}/${id}`);
  }

  addTask(task: CreateWeekPlanTaskDto): Observable<WeekPlanTask> {
    return this.http.post<WeekPlanTask>(this.apiUrl, task);
  }

  updateTask(id: string, task: WeekPlanTask): Observable<WeekPlanTask> {
    return this.http.put<WeekPlanTask>(`${this.apiUrl}/${id}`, task);
  }

  deleteTask(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}


